class FavouriteAPI {
  constructor() {
    this.baseURI = drupalSettings.path.baseUrl + drupalSettings.path.currentLanguage + '/thcb_venue_finder';
  }

  isFavourite(entityId) {
    this.endpoint = 'is_favourite';
    this.entityId = entityId;
    return this.callApi().then((results) => {return results.flagged});
  }

  favourite(entityId) {
    this.endpoint = 'favourite';
    this.entityId = entityId;
    return this.callApi().then((results) => {
      let event = new Event("update-counter");
      window.dispatchEvent(event);
      return results.flagged
    });
  }

  callApi() {
    return fetch(this.baseURI + '/' + this.endpoint + '/' + this.entityId, {credentials: "same-origin", method: 'GET'})
      .then((response) => {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response;
      })
      .then((response) => response.json())
      .then((results) => {return results})
      .catch(() => {console.log('There was an errror');});
  }

  countFavourites() {
    return fetch(this.baseURI + '/favourite_counter', {credentials: "same-origin", method: 'GET'})
      .then((response) => {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response;
      })
      .then((response) => response.json())
      .then((results) => {
        return results;
      })
      .catch((error) => {console.log(error);});
  }
}

export default FavouriteAPI;
